import { render, staticRenderFns } from "./YoutubeTopic.vue?vue&type=template&id=1cbe8eee&scoped=true"
import script from "./YoutubeTopic.vue?vue&type=script&lang=js"
export * from "./YoutubeTopic.vue?vue&type=script&lang=js"
import style0 from "./YoutubeTopic.vue?vue&type=style&index=0&id=1cbe8eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe8eee",
  null
  
)

export default component.exports